export default __webpack_public_path__ + "static/media/logo-accenture.44201538.svg";